import { useNavigate } from 'react-router-dom'
import ArrowBack from 'assets/arrow_back.svg'
import { ROUTES } from '../../../../constants'
import CFDIsZipUploadDetailsContainer from 'containers/Invoices/CFDIs/CFDIsZipUploadDetailsContainer/CFDIsZipUploadDetailsContainer'
import Button from 'components/Shared/Button/Button'
import './styles.scss'

const CFDIsZIPUploadDetailsScreen = () => {
  const navigate = useNavigate()

  return (
    <div className="screen-cfdis-zip-upload-details">
      <div className="screen-header">
        <Button
          startIcon={<img src={ArrowBack} alt="flecha hacia la izquierda" />}
          variant="hover"
          onClick={() => navigate(ROUTES.INVOICES)}>
          Volver
        </Button>
        <span>Detalle de carga CFDIs</span>
      </div>
      <div className="content">
        <CFDIsZipUploadDetailsContainer />
      </div>
    </div>
  )
}

export default CFDIsZIPUploadDetailsScreen
